import { render, staticRenderFns } from "./elderApplyPage.vue?vue&type=template&id=1bfc20b2&scoped=true&"
import script from "./elderApplyPage.vue?vue&type=script&lang=js&"
export * from "./elderApplyPage.vue?vue&type=script&lang=js&"
import style0 from "./elderApplyPage.vue?vue&type=style&index=0&id=1bfc20b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc20b2",
  null
  
)

export default component.exports